/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S7_R1_LabelInputs */

const tr_iletisim_s7_r1_label = /** @type {(inputs: Iletisim_S7_R1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüketici Hakem Heyetleri`)
};

const en_iletisim_s7_r1_label = /** @type {(inputs: Iletisim_S7_R1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüketici Hakem Heyetleri (consumer arbitration committees)`)
};

const de_iletisim_s7_r1_label = /** @type {(inputs: Iletisim_S7_R1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüketici Hakem Heyetleri (Verbraucherschlichtungsstellen)`)
};

const ru_iletisim_s7_r1_label = /** @type {(inputs: Iletisim_S7_R1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüketici Hakem Heyetleri (комиссии по потребительскому арбитражу)`)
};

/**
* | output |
* | --- |
* | "Tüketici Hakem Heyetleri (consumer arbitration committees)" |
*
* @param {Iletisim_S7_R1_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s7_r1_label = /** @type {((inputs?: Iletisim_S7_R1_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S7_R1_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s7_r1_label(inputs)
	if (locale === "de") return de_iletisim_s7_r1_label(inputs)
	if (locale === "ru") return ru_iletisim_s7_r1_label(inputs)
	return tr_iletisim_s7_r1_label(inputs)
});